var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_to-absolute-index.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_to-absolute-index.js
// module chunks = 168707334958949